module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile-500@3x_9d0f58.jpg";